require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/node_modules/core-js/fn/object/assign.js
// module id = ../../../node_modules/core-js/fn/object/assign.js
// module chunks = common